import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { OrderMatchingNavigation } from '@/components/screens/order-line-matching/navigation'
import { OrdersContainer } from '@/components/screens/order-line-matching/orders-container'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_line_matching/orders/')({ component: Page })
function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const me = useMe()
  const navigate = useNavigate()
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        {me.tenant.setting?.orderLineMatchingEnabled === true ? (
          <>
            <OrderMatchingNavigation tenantId={tenantId} value="orders" />
            <OrdersContainer
              key={tenantId}
              onOpenOrder={(orderId) => {
                void navigate({
                  to: '/t/$tenant_id/order_line_matching/orders/$order_id',
                  params: { tenant_id: tenantId, order_id: orderId },
                })
              }}
            />
          </>
        ) : (
          <ErrorPanel
            layout="section"
            title="発注明細照合機能が有効になっていません"
            description="ご利用を希望する場合は運営までお問い合わせください。"
          />
        )}
      </main>
    </div>
  )
}
